import React from 'react';
import { convertMinutesToTime } from '../../../utilities/convertMinutesToTime';

type BillableTimeProps = {
  time?: number | null;
  unit?: 'minutes' | 'seconds';
  className?: string;
  format?: 'h m s' | 'compact';
  numberClassName?: string;
  unitClassName?: string;
};

export const BillableTime: React.FC<BillableTimeProps> = ({
  time,
  unit = 'minutes',
  className = '',
  format,
  numberClassName = 'text-5xl font-bold text-main',
  unitClassName = 'text-small text-secondary',
}) => {
  const safeTime = time && !isNaN(time) ? time : 0;
  const { hour, min, sec } = convertMinutesToTime(
    unit === 'seconds' ? safeTime / 60 : safeTime
  );

  const pad = (val: number) => String(val || 0).padStart(2, '0');

  const renderDefault = () => (
    <div className={`flex items-baseline gap-1 ${className}`}>
      <span className={numberClassName}>{pad(hour)}</span>
      <span className={unitClassName}>h</span>
      <span className={numberClassName}>{pad(min)}</span>
      <span className={unitClassName}>min</span>
      <span className={numberClassName}>{pad(sec)}</span>
      <span className={unitClassName}>sec</span>
    </div>
  );

  const renderCompact = () => (
    <div className={`flex items-baseline gap-1 ${className}`}>
      <span className={numberClassName}>
        {`${pad(hour)}:${pad(min)}:${pad(sec)}`}
      </span>
    </div>
  );

  const renderSpaced = () => (
    <div className={`flex items-baseline gap-2 ${className}`}>
      <span className={numberClassName}>{pad(hour)}</span>
      <span className={unitClassName}>h</span>
      <span className={numberClassName}>{pad(min)}</span>
      <span className={unitClassName}>m</span>
      <span className={numberClassName}>{pad(sec)}</span>
      <span className={unitClassName}>s</span>
    </div>
  );

  switch (format) {
    case 'compact':
      return renderCompact();
    case 'h m s':
      return renderSpaced();
    default:
      return renderDefault();
  }
};
